import React, { useEffect, useState, useCallback } from 'react';
import { Helmet } from 'react-helmet';
import { useSelector } from 'react-redux';
import {
  MemoriaCalculoParticipanteService,
  TransformacaoBeneficioService,
} from '@services';
import { Button, Table, TableMobile } from '@components';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

export const MemoriaCalculoBeneficioPage = () => {
  const user = useSelector((state) => state.user);
  const navigate = useNavigate();
  const [dadosMemoriaCalculo, setDadosMemoriaCalculo] = useState({});
  const [dadosTransformacao, setDadosTransformacao] = useState({});
  const [isLoading, setIsLoading] = useState({
    memoriaCalculo: false,
    resumoTransformacao: false,
  });

  const memoriaCalculoParticipanteService =
    new MemoriaCalculoParticipanteService();

  const transformacaoBeneficioServiceService =
    new TransformacaoBeneficioService();

  const recuperaMemoriaCalculoBeneficio = useCallback(async () => {
    const response =
      await memoriaCalculoParticipanteService.getMemoriaCalculoBeneficioParticipante(
        user.matricula,
        user.plano
      );
    const prefixoAPI =
      response.data.ObterMemoriaCalculoBeneficioParticipanteResult;

    setDadosMemoriaCalculo({
      nomeBeneficio: `${prefixoAPI.CodigoPlano} - ${prefixoAPI.DescricaoTipoBeneficio}`,
      formaRecebimento: prefixoAPI.DescricaoFormaRecebimento,
      DIB: prefixoAPI.DIB,
      DCB: prefixoAPI.DCB,
      status: `${prefixoAPI.CodigoStatusBeneficio} - ${prefixoAPI.DescricaoStatusBeneficio}`,
    });
  }, [user.matricula, user.plano]);

  const recuperaTransformacaoBeneficio = useCallback(async () => {
    const response =
      await transformacaoBeneficioServiceService.getDadosTransformacaoBeneficio(
        user.matricula,
        user.plano
      );

    setDadosTransformacao(response);
  }, [user.matricula, user.plano]);

  useEffect(() => {
    recuperaMemoriaCalculoBeneficio();
    recuperaTransformacaoBeneficio();
  }, [recuperaMemoriaCalculoBeneficio, recuperaTransformacaoBeneficio]);

  function baixarMemoriaCalculoPDF() {
    setIsLoading({ ...isLoading, memoriaCalculo: true });
    try {
      memoriaCalculoParticipanteService
        .gerarMemoriaCalculo(user.matricula, user.plano, user.nome, user.token)
        .then((res) => {
          const blob = new Blob([res.data], { type: 'application/pdf' });
          const link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = `Memória de cálculo - ${user.matricula}.PDF`;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        })
        .finally(() => {
          setIsLoading({ ...isLoading, memoriaCalculo: false });
        });
    } catch (error) {
      toast.error(`Erro ao gerar memória de cálculo`);
      setIsLoading({ ...isLoading, memoriaCalculo: false });
    }
  }

  function baixarResumoTransformacaoPDF() {
    setIsLoading({ ...isLoading, resumoTransformacao: true });
    try {
      memoriaCalculoParticipanteService
        .gerarResumoTransformacaoBeneficio(user, dadosTransformacao)
        .then((res) => {
          const blob = new Blob([res.data], { type: 'application/pdf' });
          const link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = `Memória de cálculo - ${user.matricula}.PDF`;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        })
        .finally(() => {
          setIsLoading({ ...isLoading, resumoTransformacao: false });
        });
    } catch (error) {
      toast.error(`Erro ao gerar memória de cálculo`);
      setIsLoading({ ...isLoading, resumoTransformacao: false });
    }
  }

  return (
    <>
      <Helmet>
        <title>Forluz - Memória do cálculo de benefício</title>
      </Helmet>
      <h1 className="page-title mb-3">
        <strong>Memória Cálculo de Benefício</strong>
      </h1>
      <hr className="my-4" />
      <div className="d-flex col-3 col-md-2 col-lg-1 justify-content-center">
        <Button
          className="justify-content-center mb-32"
          transparent
          color="orange"
          icon="arrow_back"
          onClick={() => navigate(-1)}
        >
          Voltar
        </Button>
      </div>
      <div className="card">
        <div className="card-body">
          <h2>
            <strong>{user.matricula}</strong> - {user.dadosPessoais.nome}
          </h2>
          <Table
            className="d-none d-md-block mb-2 mt-32"
            columns={[
              'Nome benefício',
              'Foma recebimento',
              'DIB',
              'DCB',
              'Status',
            ]}
          >
            <tr>
              <td className="ts-10">{dadosMemoriaCalculo.nomeBeneficio}</td>
              <td className="ts-10">{dadosMemoriaCalculo.formaRecebimento}</td>
              <td className="ts-10">{dadosMemoriaCalculo.DIB}</td>
              <td className="ts-10">{dadosMemoriaCalculo.DCB}</td>
              <td className="ts-10">{dadosMemoriaCalculo.status}</td>
            </tr>
          </Table>
          <TableMobile className="mb-2">
            <div className="col-6">
              <div className="thead">Nome benefício</div>
              <div className="td">{dadosMemoriaCalculo.nomeBeneficio}</div>
            </div>
            <div className="col-6">
              <div className="thead">Foma recebimento</div>
              <div className="td">{dadosMemoriaCalculo.formaRecebimento}</div>
            </div>
            <div className="col-6">
              <div className="thead">DIB</div>
              <div className="td">{dadosMemoriaCalculo.DIB}</div>
            </div>
            <div className="col-6">
              <div className="thead">DCB</div>
              <div className="td">{dadosMemoriaCalculo.DCB}</div>
            </div>
            <div className="col-12">
              <div className="thead">Status</div>
              <div className="td">{dadosMemoriaCalculo.status}</div>
            </div>
          </TableMobile>
          <div className="row col-4 col-md-2 mb-4 mt-4">
            <Button
              onClick={() => baixarMemoriaCalculoPDF()}
              disabled={isLoading.memoriaCalculo}
            >
              {isLoading.memoriaCalculo ? 'Carregando...' : 'Baixar'}
            </Button>
          </div>
          {dadosTransformacao.codConsistencia === '7' && (
            <>
              <hr className="my-4" />
              <div className="row col-12 mb-4 mt-4">
                <div className="col-md-8">
                  <h2>
                    <strong>
                      Comprovante de Transformação de Benefício - Plano B
                    </strong>
                  </h2>

                  <p className="ts-14">
                    Registro da transformação de benefício de protocolo:{' '}
                    <b>{dadosTransformacao.protocolo}</b>.
                  </p>
                </div>
                <div className="col-md-4">
                  <Button
                    onClick={() => baixarResumoTransformacaoPDF()}
                    disabled={isLoading.resumoTransformacao}
                  >
                    {isLoading.resumoTransformacao
                      ? 'Carregando...'
                      : 'Baixar comprovante'}
                  </Button>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
};
